import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Avatar,
  Button,
  Toolbar,
  List,
  ListItem,
  Divider,
  ListItemText,
  Tooltip,
  IconButton,
  ClickAwayListener,
  Typography,
  Box,
  Link
} from '@material-ui/core';
import HeaderImage from '../Icons/enphase-logo.png';
import HeaderImageAdmin from '../Icons/AdminLogo.svg';
import settings from '../../../utils/settings';
import clsx from 'clsx';
import MenuIcon from '@material-ui/icons/Menu';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { get, keysIn, includes, isEqual } from 'lodash';
import { enlightenLinks, getToken, getCountryBasedLink, isEnlm, reDirectTo, getEnlightenOrigin } from '../../../utils/helper';
import StoreIcon from '../Icons/StoreIcon';
import HelpIcon from '../Icons/HelpIcon';
import Account from '../Icons/Account';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import User from '../Icons/User';
import { ACCOUNT_DETAILS, ACCOUNT_INFORMATION, DATA_PRIVACY, SERVICES, SUPPORT } from '../../Breadcrumb/constant';
import AccountList from '../../AccountList';
import { removeKey } from '../../../utils/localStorage';
import feature from '../../../utils/feature';
import I18n from '../../../config/locales';
import NotificationCenter from '../NotificationCenter';
import { TRAINING_DASHBOARD_LINK_IDENTIFIER } from '../constants';
import analytics from '../../../utils/analytics';
import SolargrafPopupFlow from '../../Solargraf/SolargrafPopupFlow';
import { RELEASE_NOTES_URL } from '../../../config/constants';

export const LightTooltipHeader = withStyles(theme => ({
  tooltip: {
    backgroundColor: `${theme.palette.secondary.main} !important`,
    color: '#0F0F0F !important',
    borderRadius: '0px !important',
    boxShadow: theme.shadows[1],
    fontSize: '11px !important',
    padding: '0px !important',
    top: theme.spacing(-1),
    minWidth: props => (props.notification === 'notificationCenter' ? theme.spacing(37) : theme.spacing(30)),
    pointerEvents: 'auto'
  },
  arrow: {
    color: `${theme.palette.secondary.main} !important`
  },
  popper: {}
}))(Tooltip);

const styles = theme => ({
  root: {
    display: 'flex',
    background: `${theme.palette.primary.main} !important`,
    flexDirection: 'row',
    boxShadow: 'none !important',
    zIndex: 11,
    position: 'fixed'
  },
  large: {
    width: `${theme.spacing(15)}px !important`,
    height: 'auto !important'
  },
  navigation: {
    fontSize: '16px !important',
    margin: `${theme.spacing(1)}px !important`,
    color: `${theme.palette.secondary.main} !important`,
    fontWeight: '400 !important',
    textTransform: 'none !important'
  },
  customNavigation: {
    [theme.breakpoints.between(1200, 1360)]: {
      margin: `${theme.spacing(1, 0.25)} !important`
    }
  },
  toolbar: {
    padding: '0 !important',
    minHeight: '0 !important',
    [theme.breakpoints.between(0, 1201)]: {
      padding: '3px 0px !important'
    }
  },
  headerToolbar: {
    margin: `${theme.spacing(0, 4)} !important`
  },
  customHeaderToolbar: {
    [theme.breakpoints.between(1200, 1360)]: {
      marginRight: `${theme.spacing(1)}px !important`
    }
  },
  active: {
    fontWeight: '700 !important'
  },
  mobileToolbar: {
    padding: '0px !important',
    minHeight: '0 !important',
    flexDirection: 'row-reverse',
    flexGrow: 1
  },
  menuIcon: {
    cursor: 'pointer !important',
    color: `${theme.palette.secondary.main} !important`
  },
  menuStore: {
    width: theme.spacing(4),
    height: theme.spacing(3)
  },
  fullList: {
    width: theme.spacing(25),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%'
  },
  menuList: {
    justifyContent: 'space-evenly'
  },
  rightSection: {
    marginLeft: 'auto !important',
    padding: '0 !important',
    minHeight: '0 !important'
  },
  mobileMenuIcon: {
    color: theme.palette.secondary.dark
  },
  iconButton: {
    padding: '0 !important',
    marginRight: `${theme.spacing(4.5)}px !important`,
    borderRadius: '0 !important',
    '&:hover': {
      backgroundColor: 'transparent !important'
    }
  },
  customIconButtom: {
    [theme.breakpoints.between(1200, 1360)]: {
      marginRight: `${theme.spacing(3.5)}px !important`
    }
  },
  userWrapper: {
    display: 'flex',
    alignItems: 'center',
    background: '#EAEAEA 0% 0% no-repeat padding-box',
    padding: theme.spacing(1, 2)
  },
  user: {
    color: '#0F0F0F !important',
    fontSize: '20px !important'
  },
  userIcon: {
    width: `${theme.spacing(9)}px !important`,
    height: `${theme.spacing(9)}px !important`
  },
  link: {
    fontSize: '16px !important',
    color: `${theme.palette.tertiary.main} !important`,
    padding: `${theme.spacing(1)}px  !important`,
    borderBottom: '1px solid #70707036 !important',
    '&:last-child': {
      border: 'none !important'
    }
  },
  accountWrapper: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column'
  },
  logout: {
    fontSize: '16px !important',
    color: '#0f0f0f9e !important',
    cursor: 'pointer !important'
  },
  accountRoot: {
    display: 'flex',
    flexDirection: 'column'
  },
  tooltipRootWrapper: {
    padding: theme.spacing(1)
  },
  mobileUserWrapper: {
    order: 1,
    flexDirection: 'column'
  },
  mobileAccountWrapper: {
    order: 0
  },
  userDetails: {
    marginLeft: theme.spacing(2)
  },
  mobileUserDetails: {
    marginLeft: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  mobileAccountDetailsLink: {
    border: 'none',
    borderTop: '1px solid #70707036',
    '&:last-child': {
      borderTop: '1px solid #70707036'
    }
  },
  mobileIconButton: {
    marginRight: `${theme.spacing(0)}px !important`
  },
  listItemWrapper: {
    padding: `${theme.spacing(1, 2)} !important`
  },
  hidePopper: {
    display: 'none !important'
  },
  leadCountBadge: {
    '& .MuiBadge-badge': {
      right: theme.spacing(-1),
      top: theme.spacing(0.5),
      color: theme.palette.primary.white,
      backgroundColor: '#f44336'
    }
  }
});

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      accountDropdownOpen: false,
      helpDropdownOpen: false,
      subMenu: { account: false, services: false, dataPrivacy: false, support: false },
      subMenuToHide: ''
    };
    this.adminRoles = [ 'admin', 'support_tech', 'support_read' ];
    this.windowWidth = window.innerWidth;
  }
  gaAnalytics = new analytics();

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowReSize);
    window.addEventListener('blur', () => {
      setTimeout(() => {
        if (document.activeElement.tagName === 'IFRAME') {
          this.handleAccountDropdown(false);
        }
      });
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowReSize);
  }

  handleWindowReSize = () => {
    if (this.windowWidth !== window.innerWidth) {
      this.windowWidth = window.innerWidth;
    }
  };

  handleAccountDropdown = isOpen => {
    this.setState({ accountDropdownOpen: isOpen });
  };

  handleHelpDropdown = isOpen => {
    this.setState({ helpDropdownOpen: isOpen });
  };

  setAccountInformation = (key, isOpen) => {
    const subMenu = this.state.subMenu;
    keysIn(subMenu).map(menu => (subMenu[menu] = false));
    subMenu[key] = isOpen;
    this.setState({ subMenu, subMenuToHide: '' });
  };

  trackEvent = googleAnalyticsName => {
    const dataLayer = {
      menuValue: googleAnalyticsName
    };
    this.gaAnalytics.triggerEvent({ event: 'triggerMyProfile' }, dataLayer);
  };

  toggleDrawer() {
    this.setState({ open: !this.state.open });
  }

  getIsHardLoad = () => {
    const { location } = this.props;
    const isHardLoad =
      location.pathname.includes('area-coverage') ||
      location.pathname.includes('lead-program') ||
      location.pathname.includes('branches');
    return isHardLoad;
  };

  preprod_check=(disableGeneratorToken=false)=>{
  if(disableGeneratorToken && getEnlightenOrigin().includes("preprod")){
    return true;
  }
  return false
  }

  redirect(menu, isInternal = false) {
    const { preferencesData, accountDetail, forwardTo, company, location } = this.props;
    const isSelfInstaller = get(accountDetail, 'self_installer', false);
    const isPrederedNewView = get(preferencesData, 'preferred_new_dashboard_view', false) || false;
    const isHardLoad = this.getIsHardLoad();
    const companyId = get(company, 'id', '') || get(accountDetail, 'company_id') || '';
    const onAccountPage = location.pathname === '/manager/account';
    switch (menu) {
      case 'account':
        isEnlm() && !isHardLoad
          ? isSelfInstaller ? forwardTo('/manager/account/account-details') : forwardTo('/manager/account')
          : isSelfInstaller ? reDirectTo('/manager/account/account-details') : reDirectTo('/manager/account');
        return;
      case 'admin':
        reDirectTo('/eeadmin');
        return;
      case 'admin-new':
        reDirectTo('/manager/admin');
        return;
      case 'dashboard':
        if (isPrederedNewView) {
          onAccountPage
            ? isEnlm() && isHardLoad ? forwardTo('/dashboard') : reDirectTo('/dashboard')
            : isEnlm() && isHardLoad ? forwardTo('/dashboard') : reDirectTo('/dashboard');
          return;
        } else break;
      case 'leads':
        window.open(`${window.location.origin}/manager/dashboard/${companyId}/leads`, '_blank');
        return;
      case 'fleet-dashboard-systems':
        isEnlm() ? forwardTo('/manager/dashboard/systems') : reDirectTo('/manager/dashboard/systems');
        return;
      default:
        break;
    }
    let url;
    if (isInternal) {
      url = settings.enlightenMenuUrl(menu);
      window.location.replace(url);
    } else {
      if (menu === 'enstore') url = getCountryBasedLink('enphaseStore');
      else if (menu === 'help') url = getCountryBasedLink('enlightenHelp');
      window.open(url, '_blank');
    }
  }

  getEnlightenUrl(menu, key) {
    return get(enlightenLinks(), `${menu}.${key}`);
  }

  accountDetails = (isMobile = false) => {
    const { classes, accountDetail, forwardTo } = this.props;
    const { first_name: firstname, last_name: lastname } = accountDetail;
    const pathName = window.location.pathname.includes('dashboard') ? 'dashboard' : 'account';
    let rootClass = classes.tooltipRootWrapper;
    let userWrapper = classes.userWrapper;
    let accountWrapper = classes.accountWrapper;
    let userDetails = classes.userDetails;
    let accountDetailsLink = classes.link;
    if (isMobile) {
      rootClass = clsx(rootClass, classes.accountRoot);
      userWrapper = clsx(userWrapper, classes.mobileUserWrapper);
      accountWrapper = clsx(accountWrapper, classes.mobileAccountWrapper);
      userDetails = classes.mobileUserDetails;
      accountDetailsLink = clsx(accountDetailsLink, classes.mobileAccountDetailsLink);
    }
    return (
      <ClickAwayListener onClickAway={() => this.handleAccountDropdown(false)}>
        <Box className={rootClass}>
          <Box className={userWrapper}>
            <User className={classes.userIcon} />
            <Box className={userDetails}>
              <Typography className={classes.user} id="userName">{`${firstname} ${lastname}`}</Typography>
              <Typography
                className={classes.logout}
                component="div"
                onClick={() => {
                  removeKey('_enlighten_manager_token');
                  removeKey('_solargraf_token');
                  removeKey('referrer');
                  this.redirect('logout', true);
                }}
                id="logOut"
              >
                {I18n.t('header.logOut')}
              </Typography>
            </Box>
          </Box>
          <Box className={accountWrapper}>
            {ACCOUNT_DETAILS.map(account => {
              let url = account.isBasePath ? account.url : `/manager/${pathName}/${account.url}`;
              return (
                <Link
                  key={account.label}
                  className={accountDetailsLink}
                  to={url}
                  onClick={e => {
                    this.trackEvent(account.googleAnalyticsName);
                    this.toggleDrawer();
                    this.handleAccountDropdown(false);
                    isEnlm() ? forwardTo(url) : reDirectTo(url);
                  }}
                  id={account.label}
                >
                  {I18n.t(`accountInfo.${account.name}`)}
                </Link>
              );
            })}
          </Box>
        </Box>
      </ClickAwayListener>
    );
  };

  helpDetails = (isMobile = false) => {
    const { classes, accountDetail } = this.props;
    let rootClass = classes.tooltipRootWrapper;
    let userWrapper = classes.userWrapper;
    let accountWrapper = classes.accountWrapper;
    let accountDetailsLink = classes.link;
    if (isMobile) {
      rootClass = clsx(rootClass, classes.accountRoot);
      userWrapper = clsx(userWrapper, classes.mobileUserWrapper);
      accountWrapper = clsx(accountWrapper, classes.mobileAccountWrapper);
      accountDetailsLink = clsx(accountDetailsLink, classes.mobileAccountDetailsLink);
    }
    return (
      <ClickAwayListener onClickAway={() => this.handleHelpDropdown(false)}>
        <Box className={rootClass}>
          <Box className={accountWrapper}>
                <Link
                  key='help_enphase_support'
                  className={accountDetailsLink}
                  to={getCountryBasedLink('enlightenHelp')}
                  onClick={e => {
                    this.toggleDrawer();
                    this.handleHelpDropdown(false);
                    window.open(getCountryBasedLink('enlightenHelp'), '_blank');
                  }}
                  id='help_enphase_support'
                >
                  {I18n.t('accountInfo.enphase_support')}
                </Link>
                <Link
                  key='help_whats_new'
                  className={accountDetailsLink}
                  to={RELEASE_NOTES_URL}
                  onClick={e => {
                    this.toggleDrawer();
                    this.handleHelpDropdown(false);
                    window.open(RELEASE_NOTES_URL, '_blank');
                  }}
                  id='help_whats_new'
                >
                  {I18n.t('accountInfo.whats_new')}
                </Link>
          </Box>
        </Box>
      </ClickAwayListener>
    );
  };
  subMenuList = (menu, isMobile = false) => {
    const {
      classes,
      enlightenManagerToken,
      company,
      companyInfo,
      dashboardLinks,
      companyState,
      einOptIn,
      trainingDashboardToken,
      country,
      accountDetail,
      solargrafAccess,
      setSolargrafAccess,
      forwardTo
    } = this.props;
    let rootClass = classes.tooltipRootWrapper;
    let accountWrapper = classes.accountWrapper;
    if (isMobile) {
      rootClass = clsx(rootClass, classes.accountRoot);
      accountWrapper = clsx(accountWrapper, classes.mobileAccountWrapper);
    }
    let menuItems = [];
    const ifTrainingDashboardWhetherDisplay = name =>
      name !== TRAINING_DASHBOARD_LINK_IDENTIFIER || trainingDashboardToken;
    switch (menu) {
      case 'account':
        menuItems = ACCOUNT_INFORMATION;
        break;
      case 'services':
        menuItems = SERVICES;
        break;
      case 'dataPrivacy':
        menuItems = DATA_PRIVACY;
        break;
      case 'support':
        menuItems = SUPPORT;
        break;
      default:
        menuItems = [];
        break;
    }
    return (
      <ClickAwayListener onClickAway={() => this.setAccountInformation(menu, false)}>
        <Box className={rootClass}>
          <Box className={accountWrapper}>
            {menuItems.map((account, index) => {
              const id = get(company, 'id') || get(accountDetail, 'company_id') || '';
              const state = get(company, 'address.state') || companyState || '';
              const isEinOptIn = get(companyInfo, 'ein_opt_in', false) || einOptIn;
              const hasTier = !!(get(companyInfo, 'tier.name') || '');
              const is_installer_account = get(accountDetail, "is_installer_account")|| false;
              const is_distributor = get(accountDetail,"is_distributer")||false;
              const preprod_check = this.preprod_check(true);
              return (
                ifTrainingDashboardWhetherDisplay(account.name) && (
                  <AccountList
                    key={index}
                    companyId={id}
                    accountList={account}
                    accountData={accountDetail}
                    leadOptIn={feature.isFeatureEnabled('LEAD_OPT_IN')}
                    abLreEnabled={feature.isFeatureEnabled('LRE_ENABLED')}
                    abSgipEnabled={feature.isFeatureEnabled('INCENTIVE_PROGRAM')}
                    abPermitEnabled={feature.isFeatureEnabled('PERMIT_ENABLED')}
                    abBOMEnabled={feature.isFeatureEnabled('BOM_CALCULATOR')}
                    abEinMerchandise={feature.isFeatureEnabled('EIN_MERCHANDISE')}
                    isAuthorizedSubcontractor={feature.isFeatureEnabled('AUTHORIZED_SUBCONTRACTOR')}
                    generatorTokensEnabled={!(preprod_check)? 
                      is_installer_account ||is_distributor
                        ? feature.isFeatureEnabled("GENERATOR_TOKENS")
                        : false
                    :false
                    }
                    dataPlanExtensionEnabled={feature.isFeatureEnabled('CELLMODEM_DATA_PLAN_EXTENSION')}
                    state={state}
                    title={account.name}
                    enlightenManagerToken={getToken() || enlightenManagerToken}
                    asSubMenu
                    einOptIn={isEinOptIn}
                    dashboardLinks={dashboardLinks}
                    hasTier={hasTier}
                    countryCode={country}
                    isHardLoad={this.getIsHardLoad()}
                    handleCloseTooltip={() => {
                      this.setAccountInformation(menu, false);
                      this.setState({ subMenuToHide: '' });
                    }}
                    solargrafAccess={solargrafAccess}
                    setSolargrafAccess={setSolargrafAccess}
                    forwardTo={forwardTo}
                  />
                )
              );
            })}
          </Box>
        </Box>
      </ClickAwayListener>
    );
  };

  renderDropdownMenus = (index, menu, navClass) => {
    const { accountDetail, viewOnlyAccess, classes, viewCannotEdit } = this.props;
    const isSelfInstaller = get(accountDetail, 'self_installer', false);
    const isUser = accountDetail && accountDetail.roles && isEqual(accountDetail.roles, []) === true;
    const isDemo =
      (accountDetail && accountDetail.roles && accountDetail.roles.includes('demo')) ||
      (viewOnlyAccess && !viewCannotEdit);
    if (
      (menu === 'account' && isUser && !isSelfInstaller) ||
      (includes([ 'account', 'services', 'dataPrivacy', 'support' ], menu) && isDemo)
    ) {
      return <Fragment key={index} />;
    }
    return (
      <Fragment key={index}>
        {!includes([ 'account', 'services', 'dataPrivacy', 'support' ], menu) || (menu === 'account' && isSelfInstaller) ? (
          <Button
            color="primary"
            key={index}
            className={navClass}
            onClick={() => this.onMenuClick(menu)}
            id={`${menu}Icon`}
          >
            {this.getEnlightenUrl(menu, 'name')}
          </Button>
        ) : (
          <div
            className={classes.menuIcon}
            onMouseEnter={() => this.setAccountInformation(menu, !this.state.subMenu[menu])}
            onMouseLeave={() => this.setAccountInformation(menu, false)}
          >
            <LightTooltipHeader
              onClose={() => this.setAccountInformation(menu, false)}
              open={this.state.subMenu[menu]}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title={this.subMenuList(menu)}
              arrow
              placement="bottom-end"
              classes={{
                popper: clsx(
                  `menu-list-tooltip-${menu.toLowerCase()}`,
                  this.state.subMenuToHide === menu && classes.hidePopper
                )
              }}
            >
              <Button color="primary" key={index} className={navClass} id={`${menu}Icon`}>
                {this.getEnlightenUrl(menu, 'name')}
                {this.state.subMenu[menu] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </Button>
            </LightTooltipHeader>
          </div>
        )}
      </Fragment>
    );
  };

  onMenuClick = menu => {
    const menuList = get(enlightenLinks(), `${menu}`);
    if (menuList.isExternal) {
      window.open(menuList.url, '_blank');
    } else {
      this.redirect(menuList.url, true);
      this.toggleDrawer();
    }
  };

  renderSideList = (belongsToInMxItFr = false) => {
    const { classes, preferencesData, company, accountDetail } = this.props;
    const isSelfInstaller = get(accountDetail, 'self_installer', false);
    const roles = get(accountDetail, 'roles', []) || [];
    const hasAdminRole = !!this.adminRoles.find(role => roles.includes(role));
    const companyId = get(company, 'id', '') || get(accountDetail, 'company_id') || '';
    const isPrederedNewView = get(preferencesData, 'preferred_new_dashboard_view', false) || false;
    const leadOptIn = feature.isFeatureEnabled('LEAD_OPT_IN') || false;
    return (
      <div className={classes.fullList} role="presentation">
        <List>
          {keysIn(enlightenLinks()).map((menu, index) => {
            if (menu === 'dashboard' && isSelfInstaller) {
              return <Fragment key={index} />;
            }
            if ((menu === 'admin' || menu === 'adminNew') && !(companyId.toString() === '5' && hasAdminRole)) {
              return <Fragment key={index} />;
            } else if (includes([ 'services', 'dataPrivacy' ], menu)) {
              return <React.Fragment key={index} />;
            } else if (isPrederedNewView && menu === 'account') {
              return <React.Fragment key={index} />;
            } else if (menu === 'leads' && !leadOptIn) {
              return <Fragment key={index} />;
            } else {
              return (
                <Fragment key={index}>
                  <ListItem
                    button
                    key={index}
                    onClick={() => this.onMenuClick(menu)}
                    className={classes.listItemWrapper}
                    id={`${menu}IconMobile`}
                  >
                    <ListItemText primary={this.getEnlightenUrl(menu, 'name')} />
                  </ListItem>
                  <Divider />
                </Fragment>
              );
            }
          })}
          <ListItem button className={clsx(classes.menuList, classes.listItemWrapper)}>
            {!belongsToInMxItFr && (
              <Tooltip title={I18n.t('header.enphaseStore')}>
                <IconButton
                  className={clsx(classes.iconButton, classes.mobileIconButton)}
                  onClick={() => this.redirect('enstore')}
                  id="enphaseStoreIconMobile"
                >
                  <StoreIcon
                    className={clsx(classes.menuIcon, classes.mobileMenuIcon, classes.menuStore)}
                    stroke="#7E7E7E"
                  />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title={I18n.t('header.enphaseSupport')}>
              <IconButton
                className={clsx(classes.iconButton, classes.mobileIconButton)}
                onClick={() => this.redirect('help')}
                id="enphaseSupportIconMobile"
              >
                <HelpIcon className={clsx(classes.menuIcon, classes.mobileMenuIcon)} stroke="#7E7E7E" />
              </IconButton>
            </Tooltip>
          </ListItem>
          <Divider />
        </List>
        {this.accountDetails(true)}
      </div>
    );
  };

  render() {
    const {
      classes,
      isMobileView,
      preferencesData,
      country,
      accountDetail,
      company,
      solargrafAccess,
      setSolargrafAccess,
      forwardTo
    } = this.props;
    const belongsToIn = isEqual(country, 'IN');
    const belongsToMx = isEqual(country, 'MX');
    const belongsToBr = isEqual(country, 'BR');
    const belongsToFr = isEqual(country, 'FR');
    const belongsToIt = isEqual(country, 'IT');
    const belongsToUs = isEqual(country, 'US');
    const enlightenKeys = keysIn(enlightenLinks());
    const isSelfInstaller = get(accountDetail, 'self_installer', false);
    const activeTab = enlightenKeys.find(key => includes(window.location.pathname, key));
    const isPrederedNewView = get(preferencesData, 'preferred_new_dashboard_view', false) || false;
    const belongsToInMxBrItFr = belongsToIn || belongsToMx || belongsToBr || belongsToIt || belongsToFr;
    const roles = get(accountDetail, 'roles', []) || [];
    const hasAdminRole = !!this.adminRoles.find(role => roles.includes(role));
    const companyId = get(company, 'id', '') || get(accountDetail, 'company_id') || '';
    const isAdminTabsEnabled = companyId.toString() === '5' && hasAdminRole;
    const headerImage = window.location.pathname.includes('admin-new') ? HeaderImageAdmin : HeaderImage;
    return (
      <Fragment>
        <AppBar position="static" color="secondary" className={classes.root}>
          <Toolbar
            className={clsx(classes.headerToolbar, classes.toolbar, isAdminTabsEnabled && classes.customHeaderToolbar)}
          >
            <Avatar variant="square" alt="enphase logo" src={headerImage} className={classes.large} id="enphaseLogo" />
          </Toolbar>
          {isMobileView ? (
            <Toolbar className={classes.mobileToolbar}>
              <IconButton className={classes.iconButton} onClick={() => this.toggleDrawer()} id="menuIcon">
                <MenuIcon className={classes.menuIcon} />
              </IconButton>
              {belongsToUs &&
              !isSelfInstaller && <NotificationCenter isAdminTabsEnabled={isAdminTabsEnabled} isMobileView />}
            </Toolbar>
          ) : (
            <Fragment>
              {isPrederedNewView !== undefined && (
                <Toolbar className={classes.toolbar}>
                  {enlightenKeys.map((menu, index) => {
                    if (menu === 'leads') {
                      return null;
                    }
                    if (menu === 'dashboard' && isSelfInstaller) {
                      return null;
                    }
                    if (belongsToIt && menu === 'services') {
                      return null;
                    }
                    let navClass = clsx(
                      classes.navigation,
                      menu === activeTab && classes.active,
                      isAdminTabsEnabled && classes.customNavigation
                    );
                    if ((menu === 'admin' || menu === 'adminNew') && !isAdminTabsEnabled) {
                      return <React.Fragment key={index} />;
                    } else {
                      return this.renderDropdownMenus(index, menu, navClass);
                    }
                  })}
                </Toolbar>
              )}
              <Toolbar className={classes.rightSection}>
                {belongsToUs && !isSelfInstaller && <NotificationCenter isAdminTabsEnabled={isAdminTabsEnabled} />}
                {!belongsToInMxBrItFr && (
                  <Tooltip title={I18n.t('header.enphaseStore')}>
                    <IconButton
                      id="enphaseStoreIcon"
                      className={clsx(
                        classes.iconButton,
                        classes.menuIcon,
                        isAdminTabsEnabled && classes.customIconButtom
                      )}
                      onClick={() => this.redirect('enstore')}
                    >
                      <StoreIcon className={classes.menuStore} />
                    </IconButton>
                  </Tooltip>
                )}
                {/* <Tooltip title={I18n.t('header.enphaseSupport')}>
                  <IconButton
                    id="enphaseSupportIcon"
                    className={clsx(
                      classes.iconButton,
                      classes.menuIcon,
                      isAdminTabsEnabled && classes.customIconButtom
                    )}
                    onClick={() => this.redirect('help')}
                  >
                    <HelpIcon />
                  </IconButton>
                </Tooltip> */}
                <LightTooltipHeader
                  onClose={() => this.handleHelpDropdown(false)}
                  open={this.state.helpDropdownOpen}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                  title={this.helpDetails()}
                  arrow
                  placement="bottom-end"
                >
                  <IconButton
                    className={clsx(
                      classes.iconButton,
                      classes.menuIcon,
                      isAdminTabsEnabled && classes.customIconButtom
                    )}
                    onClick={() => this.handleHelpDropdown(!this.state.helpDropdownOpen)}
                    id="enphaseSupportIcon"
                  >
                    <HelpIcon />
                    {this.state.helpDropdownOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </LightTooltipHeader>
                <LightTooltipHeader
                  onClose={() => this.handleAccountDropdown(false)}
                  open={this.state.accountDropdownOpen}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                  title={this.accountDetails()}
                  arrow
                  placement="bottom-end"
                >
                  <IconButton
                    className={clsx(classes.iconButton, classes.menuIcon)}
                    onClick={() => this.handleAccountDropdown(!this.state.accountDropdownOpen)}
                    id="accountIcon"
                  >
                    <Account />
                    {this.state.accountDropdownOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </LightTooltipHeader>
              </Toolbar>
            </Fragment>
          )}
        </AppBar>
        {isMobileView && (
          <SwipeableDrawer
            anchor="right"
            open={this.state.open}
            onClose={() => this.toggleDrawer()}
            onOpen={() => this.toggleDrawer()}
          >
            {this.renderSideList(belongsToInMxBrItFr)}
          </SwipeableDrawer>
        )}
        <SolargrafPopupFlow
          accountDetail={accountDetail}
          solargrafAccess={solargrafAccess}
          setSolargrafAccess={setSolargrafAccess}
          forwardTo={forwardTo}
        />
      </Fragment>
    );
  }
}

Header.propTypes = {
  companyId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  companyState: PropTypes.string,
  einOptIn: PropTypes.bool,
  country: PropTypes.string,
  accountDetail: PropTypes.object,
  viewOnlyAccess: PropTypes.bool,
  viewCannotEdit: PropTypes.bool,
  trainingDashboardToken: PropTypes.string,
  solargrafAccess: PropTypes.bool,
  setSolargrafAccess: PropTypes.func,
  forwardTo: PropTypes.func
};

export default withStyles(styles)(Header);
